var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('p',{staticClass:"font-weight-bold",class:[_vm.titleDisplay,  _vm.textCenter],staticStyle:{"color":"#1C1E4D !important"}},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }